import clientAxios from "../../client";

export async function evaluationCompanyShow(
  account_id: string,
  item_id: string,
) {
  return await clientAxios.get(
    `account/${account_id}/evaluation/company/${item_id}/show`,
  );
}

export async function evaluationCompanyCreate(
  account_id: string,
  evaluation_id: string,
  company_id: string,
) {
  return await clientAxios.post(
    `account/${account_id}/evaluation/company/create`,
    { evaluation_id, company_id },
  );
}

export async function evaluationCompanyPatch(
  account_id: string,
  item_id: string,
  payload: {
    address_id?: string;
    contact_id?: string;
  },
) {
  return await clientAxios.patch(
    `account/${account_id}/evaluation/company/${item_id}/patch`,
    { payload },
  );
}

export async function evaluationCompanyDelete(
  account_id: string,
  item_id: string,
) {
  return await clientAxios.del(
    `account/${account_id}/evaluation/company/${item_id}/delete`,
  );
}
